import { DefaultButton, PrimaryButton, DirectionalHint, TooltipDelay } from "@fluentui/react";
import React, { useState, useContext, useEffect, useRef } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import {isMobile} from "react-device-detect";
import { downloadPdfReport } from "../../../../service/StudyReportService";
import SearchableDropdown from "../../../IssuesAndTroubleshooting/SearchDropdown";
import { dropdownStyles } from "../../helper/initialData";
import DownloadOptions from "./DownloadOptions";
import { Stack, Dropdown } from "@fluentui/react";
import userContext from "../../../../context/users/UserContext";
import { TAB_NAME, USERTYPES, NONXRAYMODALITIES, TOAST_TYPE, REPORTDONESTATUS } from "../../../../constants/Constants";
import CrossIcon from "../../../../components/navbar/nav-icons/CrossIcon";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import QCFailModal from "./QCFailModal";
import QCReasonModal from "./QCReasonModal";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import "../../styles/styles.css";
import UploadFistolugramModal from "./UploadFistolugramModal";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import AnnotatedImageModal, { FISTULOGRAM_CONFIG, FIBROID_CONFIG } from "./AnnotatedImageModal";
import QCPassConfirmModal from "./QCPassConfirmModal";
import PreliminaryActionModal from "../ReportModals/PreliminaryActionModal/PreliminaryActionModal";
import { keyImagesPresent } from "../../../StudyViewer/helpers/KeyImageUtility";
import { t } from "i18next";
import {
  getReportTemplatesData,
  downloadFistolugramImageAsBlob,
  downloadFibroidImageAsBlob,
} from "../../../../service/StudyReportService";
import { OpenInNewWindowIcon } from "@fluentui/react-icons-mdl2";
import loaderContext from "../../../../context/loader/LoaderContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { stylesForCustomSelect } from "../../../../components/CustomSelect"
import toastContext from "../../../../context/toast/ToastContext";
import MaskButton from "../../../StudyList/components/Mask/MaskButton";
import CopyReport from "../ReportActionButtons/CopyReport";
import ResetReport from "../ReportActionButtons/ResetReport";
import { isLLMAgentPresent } from "../../../../service/MaskImageService";
import PlatformHelper from "../../../../helpers/PlatformHelper";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
// NEW (Raise Alert feature): critical-finding scan on Submit + on-demand Raise Alert button.
import CriticalAlertConfirmModal from "../../../../components/CriticalAlertModals/CriticalAlertConfirmModal";
import {
  scanReportForCriticalFindings,
  getAlertCatalogue,
} from "../../../../helpers/criticalAlert/criticalAlertService";
import { htmlToPlainText } from "../../../../helpers/criticalAlert/criticalAlertEngine";
import { fetchStudyCriticalAlerts } from "../../../../service/CriticalAlertService";
import { ENABLE_CRITICAL_ALERT_SCAN, SCAN_ALL_REPORT_TABS, MAX_SAVED_OCCURRENCES, MAX_SAVED_SENTENCE } from "../../../../components/CriticalAlertModals/criticalAlertConstants";

/**
 * NEW (Raise Alert feature): what goes into study.raise_alert for one finding.
 *
 * A finding picked from the rule library has an alertCode. A free-text finding
 * typed by the radiologist has none, so its wording is used instead -- which is
 * exactly what the old 5-option Raise Alert dropdown stored. Truncated to 45
 * because that is the width of study.raise_alert, and an over-long value would
 * fail the insert rather than being cut short.
 */
const raiseAlertValueFor = (finding) =>
  finding?.alertCode || String(finding?.findingName || "").slice(0, 45);

const AlertSubmitSection = (props) => {
  const [clearRaiseAlert, setClearRaiseAlert] = useState(null);
  const [showResetReport, setShowResetReport] = useState(false);
  const [isRaiseAlertOpen, setIsRaiseAlertOpen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const [showPreliminaryActionModal, setShowPreliminaryActionModal] = useState(false);
  // NEW (Raise Alert feature): critical-alert scan + confirmation modal state.
  const [showCriticalAlertModal, setShowCriticalAlertModal] = useState(false);
  const [criticalAlertMode, setCriticalAlertMode] = useState("SUBMIT");
  const [detectedFindings, setDetectedFindings] = useState([]);
  // manual findings confirmed on an earlier pass, seeded back into the modal
  const [preConfirmedManual, setPreConfirmedManual] = useState([]);
  const [alertCatalogue, setAlertCatalogue] = useState([]);
  const [scanning, setScanning] = useState(false);
  // set after the radiologist confirms, so submit runs once raiseAlertValue has updated
  const [submitAfterAlert, setSubmitAfterAlert] = useState(false);
  // same, for the QC Pass path. pendingQcAgentic remembers which of the two QC
  // Pass buttons was pressed (the plain one, or the formatter-agent variant).
  const [qcPassAfterAlert, setQcPassAfterAlert] = useState(false);
  const [pendingQcAgentic, setPendingQcAgentic] = useState(false);
  const pendingQcAgenticRef = useRef(false);
  const [preliminaryAfterAlert, setPreliminaryAfterAlert] = useState(false);
  const [pendingPreliminary, setPendingPreliminary] = useState(null);
  const rehydratePromiseRef = useRef(null);
  const rehydratedManualRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsPortrait(window.innerHeight > window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    handlePreviewReport,
    handlePreviewReportWithKeyImage,
    handleSaveDraft,
    handleSaveReport,
    handleMarkAsPreliminary,
    handleSubmitReport,
    handleQcPass,
    handleQcReturnButtonClick,
    handleRaiseAlertDropdown,
    userActionLoading,
    openQcReasonModal,
    setOpenQcReasonModal,
    openFistolugramUploadModal,
    openFistolugramModal,
    setOpenFistolugramModal,
    fistolugramFilePath,
    uploadFistolugramFunc,
    deleteFistolugramFunc,
    openFibroidModal,
    setOpenFibroidModal,
    fibroidFilePath,
    uploadFibroidFunc,
    deleteFibroidFunc,
    studyPatientSex,
    disableDownload,
    disablePreview,
    disableSave,
    disableSubmit,
    disableQCPass,
    disableQCReturn,
    disableRaiseAlert,
    disablePositiveNegative,
    reset,
    raiseAlertList,
    raiseAlertValue,
    setRaiseAlertValue,
    openQcModal,
    disableQCReason,
    isClientReportExist,
    patientReports,
    disableSubmitUntilQCReasonClick,
    isKeyImagesPresent,
    isTextAnnotationPresent,
    openQCPassConfirmModal,
    studyParentId,
    showPreliminaryActionPopup,
    allowDownloadReport,
    handleMarkAsSuspect,
    disableMarkAsSuspect,
    isChildStudyReportState,
    keyImagePresentStudyList,
    showMsWord,
    handleDownloadDoc,
    activeTab,
    formatterAgentEnabled,
    formattedReportUsed,
    hasAgenticReport,
    isExternal,
    reportDoneStatusState,
    reviewerId, reviewStatus,
    confirmedCriticalAlerts,
    setConfirmedCriticalAlerts,
    criticalAlertEnabled,
    registerCriticalAlertGate,
    resumeSubmitAfterCriticalAlert,
    resumeQcPassAfterCriticalAlert,
    markCriticalAlertsConfirmed,
    studyId,
    activeTabKey,
    // NEW (Raise Alert feature): labels the evidence line with the template it
    // came from, when the report has more than one tab
    currentActiveTab,
    editorRef,
    handleModelChange,
    studyDescription,
    modality,
    disableEditReport,
  } = useContext(studyReportContext);

  const {
      handleDSRRegenerate,
    } = useContext(AgenticReportingContext);

  const annotationContext = useContext(AnnotationContext) || {};
  const { handleNegativeSubmitReport } = annotationContext; 
  const extReportRecieved = (props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true) ? false : props.extReportReived;
  const { getThemeColor,themeName,getAlterColor } = useContext(themeContext);
  // const { createAnnotationJson } = useContext(AnnotationContext);
  let [showInfo1, setShowInfo1] = useState(false);

  const { roles, username, authenticated, loadByUsername, userId, isActiveData, enableLlmReport} =
    useContext(userContext);

  const { loaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);


  const clearValue = () => {
    // console.log("test");
  };

  const updatedStylesDisable = {
    root: {
      // background:'#404040',
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      padding: 0,
    },
  };

  const updatedStylesEnable = {
    root: {
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesEnableMobileSuspect = {
    root: {
      height: "28px",
      minWidth: 0,
      padding: "0 6px",
      fontSize: "11px",
    },
  };

  const mobileCompactButton = {
    root: {
      height: "28px",
      minWidth: 0,
      padding: "0 8px",
      fontSize: "11px",
    },
  };

  
  const updatedStylesEnableMSWord = {
    root: {
      height: "28px",
      width: "90px",
      // left: "-5px"
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingSubmit = {
    root: {
      height: "28px",
      width: "80px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingQCPass = {
    root: {
      height: "28px",
      width: "85px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const iconButtonStyles = {
    root: {
      height: "28px",
      minWidth: "40px",
      width: "40px",
      padding: 0,
    },
    icon: {
      fontSize: "16px",
    },
  };


  const hasRow1ActionButtons = () => {
    let count = 0;
    if (activeTab !== 3 && !disableMarkAsSuspect && !isChildStudyReportState && !PlatformHelper.isFahes()) count++;
    if (activeTab !== 3 && !disablePreview && !isChildStudyReportState) count++;
    if (activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && !disableDownload && !isChildStudyReportState) count++;
    if (!isMobile && activeTab !== 3 && !(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)) && showMsWord && !PlatformHelper.isFahes() && !disableEditReport) count++;
    if (activeTab !== 3 && !disableQCReason && !isChildStudyReportState) count++;
    if (activeTab !== 3 && !disableQCPass && !isChildStudyReportState) count++;
    if (activeTab !== 3 && !disableQCReturn && !isChildStudyReportState) count++;
    if (activeTab === 3 && !disableEditReport && (isExternal || !NONXRAYMODALITIES.includes(props.modality))) count++;
    return isPortrait && count >= 3;
  };

  const checkForSaveButton = ()=>{
   
     return !disableSave && !isChildStudyReportState && activeTab !== 3 && !PlatformHelper.isFahes(); 
    
  }

  const checkForSubmitButton = (getThemeColor) => {
    return !disableSubmit && !isChildStudyReportState && activeTab !== 3 && !PlatformHelper.isFahes();
  }

  const checkForPositiveNegativeButton = (getThemeColor) => {
    return !disableSubmit && !disablePositiveNegative &&!isChildStudyReportState && activeTab !== 3 && PlatformHelper.isFahes();
  }

  // NEW (Raise Alert feature): the real submit call, pulled out so the critical-alert scan
  // can run before it. Behaviour is identical to the previous inline onClick.
  const submitReportNow = () => {
    handleSubmitReport(
      true,
      props.keyImages,
      props.annotationData,
      props.annotationDataAI,
      props.allTextToolAnnotation,
      props.activeViewportIndex,
      false, false
    );
  };

  // NEW (Raise Alert feature): raiseAlertValue is context state, so it is not visible to
  // handleSubmitReport in the same tick. Submit on the next render instead.
  useEffect(() => {
    if (submitAfterAlert) {
      setSubmitAfterAlert(false);
      // OLD: re-ran handleSubmitReport from the top, which re-entered the whole guard chain.
      // Now that the alert is the LAST prompt, resume at the real submit instead - every
      // other check has already been cleared on the way in.
//      submitReportNow();
      resumeSubmitAfterCriticalAlert();
    }
  }, [submitAfterAlert, raiseAlertValue]);

  // NEW (Raise Alert feature): same one-render delay for QC Pass, so raiseAlertValue and
  // confirmedCriticalAlerts are visible to the payload builder before it runs.
  useEffect(() => {
    if (qcPassAfterAlert) {
      setQcPassAfterAlert(false);
      // OLD: re-ran handleQcPass from the top - see the submit effect above.
//      runQcPassNow(pendingQcAgentic);
      resumeQcPassAfterCriticalAlert();
    }
  }, [qcPassAfterAlert, raiseAlertValue]);

  // NEW (Raise Alert feature): and for Mark as Preliminary.
  useEffect(() => {
    if (preliminaryAfterAlert) {
      setPreliminaryAfterAlert(false);
      runPreliminaryNow(pendingPreliminary);
      setPendingPreliminary(null);
    }
  }, [preliminaryAfterAlert, raiseAlertValue]);

  // NEW (Raise Alert feature): the live report HTML.
  //
  // Two ways of getting it, because editorRef alone is not reliable: CustomEditor
  // has three separate `ref={editorRef}` render branches (basic / LLM / advanced),
  // so whether the ref holds a usable Froala instance depends on which branch is
  // mounted. When it does not, we read the Froala editable div straight from the
  // DOM instead.
  //
  // TODO: a study can hold several reports (finalReport + addendum per template);
  const getReportHtmlForScan = () => {
    const parts = [];
    const sources = [];
    /* Which template each part came from, so an evidence line in the modal can
     * say where the sentence was written. Kept parallel to `parts`. */
    const origins = [];

    // --- the tab on screen: read the live editor so unsaved edits count ---
    let activeHtml = "";
    try {
      activeHtml = editorRef?.current?.editor?.html?.get() || "";
    } catch (error) {
      console.warn("[Raise Alert feature] editorRef unreadable:", error?.message);
    }
    // fall back to the Froala editable div — CustomEditor has three separate
    // `ref={editorRef}` render branches, so the ref is not always usable
    if (!activeHtml.trim()) {
      try {
        activeHtml = document.querySelector(".fr-element.fr-view")?.innerHTML || "";
        if (activeHtml.trim()) {
          sources.push("visible tab (DOM)");
        }
      } catch (error) {
        console.warn("[Raise Alert feature] DOM read failed:", error?.message);
      }
    } else {
      sources.push("visible tab (editor)");
    }

    /* --- every tab's content from patientReports ---
     *
     * patientReports is what getReportContent() builds the submit payload from,
     * so scanning it scans exactly what is about to be saved. handleModelChange
     * mirrors the editor into the active tab's entry as the radiologist types,
     * so these are current, not last-saved.
     *
     * NO TAB IS SKIPPED, deliberately. This used to skip the entry matching
     * activeTabKey on the grounds that the live editor above had already covered
     * it. But setActiveTabKey() only runs inside an `if (key)` guard in
     * StudyReportState.handleChangeTemplate, so switching to a tab that has no
     * key leaves activeTabKey pointing at the PREVIOUS tab -- and the scan then
     * skipped the wrong one. Submitting from a second template read only that
     * template, and a finding written in the first was silently missed.
     *
     * Reading a tab twice is harmless: the engine deduplicates evidence per
     * sentence, so the same line cannot appear twice under one finding. Given a
     * choice between double-reading and missing a critical finding, double-read.
     */
    if (SCAN_ALL_REPORT_TABS && Array.isArray(patientReports)) {
      patientReports.forEach((report) => {
        const details = report?.reportDetails || report?.report || {};
        let chars = 0;
        [details.finalReport, details.report, details.addendum].forEach((html) => {
          if (html && String(html).trim().length > 0) {
            parts.push(String(html));
            chars += String(html).length;
          }
        });
        const label = report?.text || report?.key || "Report";
        if (chars > 0) {
          origins.push({
            label,
            html: [details.finalReport, details.report, details.addendum]
              .filter((h) => h && String(h).trim().length > 0)
              .join("\n<br/>\n"),
          });
        }
        sources.push(`tab "${label}" (${chars} chars)`);
      });
    }

    /* The live editor goes LAST, after the tabs.
     *
     * It is a safety net for edits the radiologist has typed but that
     * handleModelChange has not mirrored into patientReports yet, so it usually
     * duplicates the active tab. Appending rather than prepending it keeps the
     * evidence in tab order no matter which tab Submit was pressed from -- the
     * engine keeps the first occurrence of each sentence, so the duplicate is
     * dropped and only genuinely unsaved text survives from here. */
    if (activeHtml.trim()) {
      parts.push(activeHtml);
      origins.push({ label: currentActiveTab || "Open tab", html: activeHtml });
    }

    if (parts.length === 0) {
      console.warn(
        "[Raise Alert feature] NO REPORT TEXT FOUND — nothing to scan. editorRef.current is",
        editorRef?.current ? "set but unusable" : "null",
        `, no .fr-element.fr-view in the DOM, and patientReports has ${
          patientReports?.length || 0
        } entries.`
      );
      return "";
    }

    // <br/> between reports so no sentence ever spans two of them — negation is
    // sentence-scoped, and a merged sentence would let one report's "No" suppress
    // a real finding in the next
    const combined = parts.join("\n<br/>\n");
    console.warn(
      `[Raise Alert feature] report text read from ${parts.length} source(s) ` +
        `(${combined.length} chars): ${sources.join(", ")}`
    );
    return { html: combined, origins };
  };

  /* Tag every piece of evidence with the template it came from.
   *
   * The scan deliberately runs on all tabs concatenated: report-scoped
   * suppression -- "discussed with the team" written in one tab silencing a
   * finding in another -- only works when the engine sees the whole report at
   * once. So rather than scan each tab separately, the sentence is located
   * afterwards. Whichever tab's text contains it is where it was written.
   *
   * A sentence present in two templates gets both labels. That is the honest
   * answer: it really was written twice. */
  const annotateFindingSources = (fired, origins) => {
    if (!Array.isArray(fired) || !Array.isArray(origins) || origins.length < 2) {
      return fired; // a single source would put the same label on every line
    }
    const flat = (v) => String(v || "").replace(/\s+/g, " ").trim().toLowerCase();
    const plain = origins.map((o) => ({
      label: o.label,
      text: flat(htmlToPlainText(o.html)),
    }));

    fired.forEach((finding) => {
      (finding.occurrences || []).forEach((occ) => {
        const needle = flat(occ.matchedSentence);
        occ.sources = needle
          ? Array.from(
              new Set(
                plain.filter((x) => x.text.includes(needle)).map((x) => x.label)
              )
            )
          : [];
      });
    });
    return fired;
  };

  const runCriticalAlertScan = async () => {
    const { html, origins } = getReportHtmlForScan();
    const scanModality = props.modality || modality;

    const result = await scanReportForCriticalFindings({
      html,
      modality: scanModality,
      studyDescription: studyDescription,
      criticalAlertEnabled,
    });
    annotateFindingSources(result?.fired, origins);
    return result;
  };
  
  useEffect(() => {
    if (!ENABLE_CRITICAL_ALERT_SCAN || !studyId) {
      return undefined;
    }
    let cancelled = false;
    rehydratePromiseRef.current = fetchStudyCriticalAlerts(studyId).then((rows) => {
      if (cancelled) {
        return [];
      }
      const manual = (rows || [])
        .filter((f) => f && f.source === "MANUAL" && f.findingName)
        .map((f) => ({
          alertCode: f.alertCode || null,
          findingName: f.findingName,
          priority: f.priority || null,
          matchedTerm: f.matchedTerm || null,
          matchedSentence: f.matchedSentence || null,
          occurrences: Array.isArray(f.occurrences) ? f.occurrences : null,
          source: "MANUAL",
        }));
      // filled even when empty, so a later reader can tell "none" from "not read yet"
      rehydratedManualRef.current = manual;
      if (manual.length === 0) {
        return manual;
      }
      console.warn(
        `[Raise Alert feature] rehydrated ${manual.length} manual finding(s) already raised ` +
          `on study ${studyId}: ${JSON.stringify(manual.map((f) => f.findingName))}`
      );
      // functional update: if this request resolved late, never overwrite a confirmation
      // the radiologist has already made in this session
      setConfirmedCriticalAlerts((current) => (current === null ? manual : current));
      return manual;
    });
    return () => {
      cancelled = true;
    };
  }, [studyId]);

  /* Manual findings confirmed on an EARLIER pass, carried forward into this one.
   *
   * A scan can re-derive every auto-detected finding from the report text. It can
   * never re-derive a manual one. So a radiologist who raised a manual alert from
   * the Raise Alert button, then edited the report, then submitted, lost it: the
   * modal only ever showed the scan results, and confirming REPLACED the stored
   * set rather than adding to it.
   *
   * Deduplicated against what the scan just found -- if the new report text now
   * detects the same finding, the detected one wins, because it carries the
   * matched sentence as evidence.
   */
  const carriedManualFindings = () => {
    const keyOf = (f) => f.alertCode || `free-text:${f.findingName}`;
    const source = confirmedCriticalAlerts || rehydratedManualRef.current || [];
    return source
      .filter((f) => f && f.source === "MANUAL" && f.findingName)
      .map((f) => ({ ...f, isManual: true, isFreeText: !f.alertCode }));
  };

  const alertStudyContext = () => ({
    modality: props.modality || modality,
    studyDescription: studyDescription,
  });

  const openAlertModal = (findings, openMode) => {
    const keyOf = (f) => f.alertCode || `free-text:${f.findingName}`;
    const detectedKeys = new Set((findings || []).map(keyOf));
    const carried = carriedManualFindings().filter((f) => !detectedKeys.has(keyOf(f)));
    if (carried.length > 0) {
      console.warn(
        `[Raise Alert feature] carrying ${carried.length} manual finding(s) forward ` +
          `into the ${openMode} modal: ${JSON.stringify(carried.map((f) => f.findingName))}`
      );
    }
    setDetectedFindings(findings || []);
    setPreConfirmedManual(carried);
    setCriticalAlertMode(openMode);
    setShowCriticalAlertModal(true);
  };

  // NEW (Raise Alert feature): used when this submit raises nothing automatically — either
  // the scan found nothing, or the radiologist pressed "Submit without alert".
  //
  // Both cases must RETIRE whatever was raised before, otherwise the badge and
  // the ALERT RAISED modal keep showing findings this submit did not support.
  //
  // Sending an EMPTY ARRAY is what triggers it. The backend treats [] as "this
  // submit raises nothing, clear the study" and null as "this submit says
  // nothing about alerts, leave them alone". Those must stay different, or every
  // other submit path — QC Pass, preliminary, an older client — would wipe
  // alerts it knows nothing about.
  //
  // Findings the radiologist added by hand survive a scan that finds nothing:
  // they were a deliberate act rather than something derived from the report
  // text, and nothing was shown for them to decline.
  //
  // `declined` flips that. The modal now seeds itself with manual findings from
  // an earlier pass, so pressing "Submit without alert" IS an explicit decline
  // of everything listed -- manual entries included. Retiring only the
  // auto-detected ones there would leave an alert the radiologist just declined.
  const retireAutoDetectedThenSubmit = (declined = false) => {
    const keptManual = declined
      ? []
      : (confirmedCriticalAlerts || []).filter((f) => f.source === "MANUAL");

    console.warn(
      `[Raise Alert feature] retiring auto-detected alerts, keeping ${keptManual.length} manual one(s)`
    );

    setConfirmedCriticalAlerts(keptManual);
    markCriticalAlertsConfirmed?.();

    if (keptManual.length > 0) {
      handleRaiseAlertDropdown({
        value: raiseAlertValueFor(keptManual[0]),
        label: keptManual[0].findingName,
      });
    } else if (raiseAlertValue) {
      handleRaiseAlertDropdown(null); // clears it, so the badge disappears
    }

    // submit on the next render, once raiseAlertValue has actually updated
    setSubmitAfterAlert(true);
  };

  /* OLD (Raise Alert feature): Submit scanned here, BEFORE handleSubmitReport ran, so the
     alert modal was the first prompt of the submit. Everything handleSubmitReport checks
     afterwards - blank/empty report, the HL7 character notice, the formatter-agent prompt -
     aborts with a return, so a radiologist could confirm alerts and then watch the submit be
     discarded, then get asked to confirm them all over again on the next click.

//  const handleSubmitClick = async () => {
//    if (!ENABLE_CRITICAL_ALERT_SCAN) {
//      submitReportNow();
//      return;
//    }
//    try {
//      await rehydratePromiseRef.current;
//    } catch (ignored) {}
//    setScanning(true);
//    try {
//      const [result, catalogue] = await Promise.all([
//        runCriticalAlertScan(),
//        getAlertCatalogue(alertStudyContext()),
//      ]);
//      setAlertCatalogue(catalogue);
//      if (result.fired.length === 0) {
//        retireAutoDetectedThenSubmit();
//        return;
//      }
//      openAlertModal(result.fired, "SUBMIT");
//    } catch (error) {
//      submitReportNow();
//    } finally {
//      setScanning(false);
//    }
//  };
  */

  // NEW (Raise Alert ordering): the button just starts the submit. The scan now runs from the
  // gate below, which the context calls once every other prompt has been cleared.
  const handleSubmitClick = () => {
    submitReportNow();
  };

  /* NEW (Raise Alert ordering): the gate the context calls as its last step, for both Submit
     and QC Pass. Returns true when it has taken over - the modal is open, or stale alerts were
     retired - because in both of those cases the matching *AfterAlert effect finishes the
     action. Returns false when the caller should carry straight on.

     The scan body is exactly what handleSubmitClick used to run; only where it is called from
     has changed. */
  const runCriticalAlertGate = async (mode) => {
    if (!ENABLE_CRITICAL_ALERT_SCAN) return false;

    // wait for the study's existing manual findings to be read, so a fast click cannot
    // open the modal before they are known
    try {
      await rehydratePromiseRef.current;
    } catch (ignored) {
      // the read swallows its own errors; nothing to do but carry on
    }
    setScanning(true);
    try {
      const [result, catalogue] = await Promise.all([
        runCriticalAlertScan(),
        getAlertCatalogue(alertStudyContext()),
      ]);
      setAlertCatalogue(catalogue);

      if (result.fired.length === 0) {
        console.warn(`[raise-alert] ${mode} — no critical findings in the report`);
        // still has to run: it retires anything a previous pass raised, then resumes
        if (mode === "QC") {
          retireAutoDetectedThenQcPass(pendingQcAgenticRef.current);
        } else {
          retireAutoDetectedThenSubmit();
        }
        return true;
      }
      openAlertModal(result.fired, mode === "QC" ? "QC_PASS" : "SUBMIT");
      return true;
    } catch (error) {
      // never block a submission because the scan misbehaved
      console.warn(`[raise-alert] ${mode} scan errored — continuing without the prompt:`, error);
      return false;
    } finally {
      setScanning(false);
    }
  };

  // Re-registered every render on purpose: the gate closes over report content and alert
  // state, and a gate captured once would scan a stale report.
  useEffect(() => {
    registerCriticalAlertGate?.(runCriticalAlertGate);
  });

  /* NEW (Raise Alert feature): Mark as Preliminary, scanned and prompted like Submit.
   *
   * ROLE-GATED BY DESIGN. This is one button whose label is "Preliminary" for a
   * radiologist or typist and "Save" for everyone else, both calling the same handler.
   * Only the Preliminary reading is a release, so only that one prompts -- a plain
   * Save must stay silent or every save becomes a dialog.
   */
  const isPreliminaryRelease = () =>
    roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.TYPIST);

  const runPreliminaryNow = (args) => {
    (handleMarkAsPreliminary || handleSaveReport)(
      true,
      args?.keyImages,
      args?.annotationData,
      args?.annotationDataAI,
      args?.allTextToolAnnotation,
      args?.activeViewportIndex,
      undefined,
      undefined,
      undefined,
      args?.preliminaryPostAction || null
    );
  };

  // Retire whatever the last pass raised, then mark preliminary. `declined` is set by
  // the modal's skip button, where the manual findings were listed and so are being
  // declined explicitly -- the same rule as the submit and QC paths.
  const retireAutoDetectedThenPreliminary = (declined = false) => {
    const keptManual = declined
      ? []
      : (confirmedCriticalAlerts || []).filter((f) => f.source === "MANUAL");
    console.warn(
      `[Raise Alert feature] Preliminary — retiring auto-detected alerts, keeping ${keptManual.length} manual one(s)`
    );
    setConfirmedCriticalAlerts(keptManual);
    markCriticalAlertsConfirmed?.();
    if (keptManual.length > 0) {
      handleRaiseAlertDropdown({
        value: raiseAlertValueFor(keptManual[0]),
        label: keptManual[0].findingName,
      });
    } else if (raiseAlertValue) {
      handleRaiseAlertDropdown(null);
    }
    setPreliminaryAfterAlert(true);
  };

  const handlePreliminaryClick = async (args) => {
    /* "Save" (any non-radiologist role) and the feature-off case are untouched by
       this change: straight through, synchronously, no scan and no deferral. Only
       the release reading of this button pays for the prompt. */
    if (!ENABLE_CRITICAL_ALERT_SCAN || !isPreliminaryRelease()) {
      runPreliminaryNow(args);
      return;
    }
    setPendingPreliminary(args);
    // wait for the study's existing manual findings to be read, so a fast click cannot
    // open the modal before they are known
    try {
      await rehydratePromiseRef.current;
    } catch (ignored) {
      // the read swallows its own errors; nothing to do but carry on
    }
    setScanning(true);
    try {
      const [result, catalogue] = await Promise.all([
        runCriticalAlertScan(),
        getAlertCatalogue(alertStudyContext()),
      ]);
      setAlertCatalogue(catalogue);

      if (result.fired.length === 0) {
        console.warn("[Raise Alert feature] Preliminary — no critical findings in the report");
        retireAutoDetectedThenPreliminary();
        return;
      }
      openAlertModal(result.fired, "PRELIMINARY");
    } catch (error) {
      // a misbehaving scan must never block a preliminary release
      console.warn("[Raise Alert feature] scan errored — marking preliminary normally:", error);
      runPreliminaryNow(args);
    } finally {
      setScanning(false);
    }
  };

  // NEW (Raise Alert feature): QC Pass. Operations asked for the prompt here too, because QC
  // is the final checkpoint before the report reaches the clinician (feedback Q2).
  //
  // Same shape as handleSubmitClick: scan, show the modal only if something fired,
  // otherwise pass through untouched.
  const runQcPassNow = (useAgenticFormatting) => {
    handleQcPass(
      studyParentId,
      props.keyImages,
      props.qcData,
      props.allTextToolAnnotation,
      true,
      useAgenticFormatting
    );
  };

  /* OLD (Raise Alert feature): QC Pass scanned here, before handleQcPass ran, so the alert
     modal came before QC's own key-image, HL7 and formatter prompts - same discarded-action
     problem as Submit had.

//  const handleQcPassClick = async (useAgenticFormatting) => {
//    if (!ENABLE_CRITICAL_ALERT_SCAN) {
//      runQcPassNow(useAgenticFormatting);
//      return;
//    }
//    try {
//      await rehydratePromiseRef.current;
//    } catch (ignored) {}
//    setScanning(true);
//    try {
//      const [result, catalogue] = await Promise.all([
//        runCriticalAlertScan(),
//        getAlertCatalogue(alertStudyContext()),
//      ]);
//      setAlertCatalogue(catalogue);
//      if (result.fired.length === 0) {
//        retireAutoDetectedThenQcPass(useAgenticFormatting);
//        return;
//      }
//      setPendingQcAgentic(useAgenticFormatting);
//      openAlertModal(result.fired, "QC_PASS");
//    } catch (error) {
//      runQcPassNow(useAgenticFormatting);
//    } finally {
//      setScanning(false);
//    }
//  };
  */

  // NEW (Raise Alert ordering): start QC Pass; the gate runs at the end of proceedWithQCPass.
  // The agentic flag goes into a ref as well as state because the gate reads it from a closure
  // captured on the previous render, where the state value would still be the old one.
  const handleQcPassClick = (useAgenticFormatting) => {
    pendingQcAgenticRef.current = useAgenticFormatting;
    setPendingQcAgentic(useAgenticFormatting);
    runQcPassNow(useAgenticFormatting);
  };

  // Same retire-then-proceed logic as the submit path, but ending in QC Pass.
  // `declined` as in retireAutoDetectedThenSubmit: set on the "QC Pass without
  // alert" path, where the modal listed the manual findings too.
  const retireAutoDetectedThenQcPass = (useAgenticFormatting, declined = false) => {
    const keptManual = declined
      ? []
      : (confirmedCriticalAlerts || []).filter((f) => f.source === "MANUAL");
    console.warn(
      `[Raise Alert feature] QC Pass — retiring auto-detected alerts, keeping ${keptManual.length} manual one(s)`
    );
    setConfirmedCriticalAlerts(keptManual);
    markCriticalAlertsConfirmed?.();
    if (keptManual.length > 0) {
      handleRaiseAlertDropdown({
        value: raiseAlertValueFor(keptManual[0]),
        label: keptManual[0].findingName,
      });
    } else if (raiseAlertValue) {
      handleRaiseAlertDropdown(null);
    }
    setPendingQcAgentic(useAgenticFormatting);
    setQcPassAfterAlert(true);
  };

  // NEW (Raise Alert feature): the Raise Alert button that replaces the old dropdown.
  // Scans too, so anything detectable is pre-filled, then lets the radiologist
  // add findings by hand — this is what keeps manual alerts possible.
  const handleRaiseAlertClick = async () => {
    // wait for the study's existing manual findings to be read, so a fast click cannot
    // open the modal before they are known
    try {
      await rehydratePromiseRef.current;
    } catch (ignored) {
      // the read swallows its own errors; nothing to do but carry on
    }
    setScanning(true);
    try {
      const [result, catalogue] = await Promise.all([
        runCriticalAlertScan(),
        getAlertCatalogue(alertStudyContext()),
      ]);
      setAlertCatalogue(catalogue);
      openAlertModal(result.fired, "MANUAL");
    } catch (error) {
      console.warn("[Raise Alert feature] scan errored — opening empty alert modal:", error);
      setAlertCatalogue(await getAlertCatalogue(alertStudyContext()).catch(() => []));
      openAlertModal([], "MANUAL");
    } finally {
      setScanning(false);
    }
  };

  // NEW (Raise Alert feature): feed the confirmed findings into the submit payload.
  // raiseAlertValue keeps the single highest-priority code so the existing flow,
  // the studylist badge and the analytics queries are untouched;
  // confirmedCriticalAlerts carries the full set for study_critical_alert.
  const applyConfirmedFindings = (selectedFindings) => {
    const primary = selectedFindings[0]; // modal sorts most serious first
    if (primary) {
      handleRaiseAlertDropdown({
        value: raiseAlertValueFor(primary),
        label: primary.findingName,
      });
    }

    setConfirmedCriticalAlerts(
      selectedFindings.map((f) => ({
        alertCode: f.alertCode || null,
        findingName: f.findingName,
        priority: f.priority || null,
        matchedTerm: f.matchedTerm || null,
        matchedSentence: f.matchedSentence || null,
        occurrences: (f.occurrences || [])
          .slice(0, MAX_SAVED_OCCURRENCES)
          .map((o) => ({
            matchedTerm: o.matchedTerm || null,
            matchedSentence: String(o.matchedSentence || "").slice(0, MAX_SAVED_SENTENCE),
            sources: Array.isArray(o.sources) && o.sources.length > 0 ? o.sources : null,
          })),
        source: f.isManual ? "MANUAL" : "AUTO_CONFIRMED",
      }))
    );

    // the radiologist has committed to this set -- Save and Mark as Preliminary may
    // now persist it, not just the real submit
    markCriticalAlertsConfirmed?.();

    console.warn(
      "[Raise Alert feature] confirmed findings queued for submit:",
      selectedFindings.map((f) => f.alertCode)
    );
  };

  const getRaiseAlertLabel = (value) => {
      let data = raiseAlertList;
      if(data != null && data != undefined && data?.length > 0){
        const result = data.find(item => item.value === value);
        if (result) {
          return result?.label
        }
        return value;
      }else{
        return null;
      }
  }

  useEffect(() => {
    const elements = document.getElementsByClassName("react-select__input-container");
  
    if (elements.length > 0 && window.location.href.includes("studylist")) {
      // Convert the HTMLCollection to an array and set the style for each element
      Array.from(elements).forEach(element => {
        element.style.color = getThemeColor("primary-color");
      });
    }
  },[raiseAlertValue,themeName])

  const checkForPeerReviewReportDownloadAvailable = () => {
    if(reviewerId != null && reviewStatus != 1){
      return true;
    }
    return false;
  }

  const checkForDownloadAvailable = () => {
    if(reviewerId != null && reviewerId == userId){
      return false;
    }
    return true;
  }

  if (isMobile && props.readOnly) {
    return (
      <div className="mobile-download-box-wrapper">
      {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && 
        !disableDownload && 
        !isChildStudyReportState && (
          <div className="mobile-download-buttons">
          <DefaultButton
            text={t("button.download")}
            disabled={disableDownload}
            styles={updatedStylesDisable}
            onClick={() => {
              if (showInfo1) {
                // console.log("False");
                setShowInfo1(false);
              } else {
                // console.log("True");
                setShowInfo1(true);
              }
            }}
          />
        <DownloadOptions
          studyParentId={studyParentId}
          show={showInfo1}
          onClickOutside={() => setShowInfo1(false)}
          modality={props.modality}
          isKeyImagesPresent={
            props.isStudyList
              ? keyImagePresentStudyList
              : keyImagePresentStudyList || keyImagesPresent(props.keyImages)
          }
          isExtReportReceived={extReportRecieved}
          reportOptions={checkForDownloadAvailable()}
          peerReviewReportOptions={checkForPeerReviewReportDownloadAvailable()}
        />
      </div>)}
   
        </div>
    );
  } else {
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        height: hasRow1ActionButtons() ? "80px" : "42px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", 
        padding: props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true ? '8px' : '',
        width: "100%",
        // ...((enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && { paddingLeft: 0 })
      }}
    >
      {!isChildStudyReportState && <div className="ms-Grid-row" style={{ width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "4px" }}>




   
        

            {/* {enableLlmReport && isLLMAgentPresent(props.modality, studyDescription ) && (
              <div style={{ display: "flex", alignItems: "center"}} >
                <ReportTemplateIndicator/>
                <ResetReport/>
                <CopyReport/>

              </div>
            )} */}
           
          
          {/* Buttons: Row 1 = action buttons, Row 2 = Save / Submit */}
          <div className="bottom-button" style={{ display: "flex", flexDirection: hasRow1ActionButtons() ? "column" : "row", width: "100%", gap: hasRow1ActionButtons() ? "4px" : "6px", alignItems: hasRow1ActionButtons() ? "stretch" : "center" }}>

            {/* Row 1: Raise Alert + action buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: hasRow1ActionButtons() ? undefined : 1 }}>

            {/* OLD (Raise Alert feature): the 5-item CreatableSelect dropdown. Replaced by the
                Raise Alert button below, which opens the critical-alert modal so
                multiple findings can be raised. Kept for reference / quick rollback.
            {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR) )  && !disableRaiseAlert && (
          <div
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4 parent-dropdown"
            style={{
               marginRight: "8px",
               minWidth: 0,
               ...(isMobile && { width: "120px", flex: "0 0 120px", maxWidth: "120px" }),
               ...((enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && { marginLeft: "-5px", paddingLeft: 0 })
            }}>
            <CustomToolTipHost content={isRaiseAlertOpen ? undefined : (!raiseAlertValue ? t("placeholder.raise-alert") : undefined)} id="raise-alert-tooltip">
              <CreatableSelect
                menuPlacement="top"
                menuPosition="fixed"
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                onMenuOpen={() => setIsRaiseAlertOpen(true)}
                onMenuClose={() => setIsRaiseAlertOpen(false)}
                styles={{
                  ...stylesForCustomSelect(getThemeColor),
                  menuPortal: (base) => ({ ...base, zIndex: 10000001 }),
                }}
                defaultValue={
                  raiseAlertValue != undefined &&
                  raiseAlertValue != null &&
                  raiseAlertValue != ""
                    ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                    : null
                }
                onChange={(ele) => {
                  handleRaiseAlertDropdown(ele);
                }}
                placeholder={t("placeholder.raise-alert")}
                isClearable
                options={raiseAlertList}
              />
            </CustomToolTipHost>
          </div>
        )} */}

            {/* NEW (Raise Alert feature): Raise Alert button. Same visibility conditions as the
                dropdown it replaces — Radiologist/Supervisor and !disableRaiseAlert. */}
            {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR)) && !disableRaiseAlert && (
              <div
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2"
                style={{
                  marginRight: "8px",
                  paddingLeft: 0,
                  paddingRight: 0,
                  width: "auto",
                  minWidth: 0,
                  ...(isMobile && { flexShrink: 0 }),
                  ...((enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)) && { marginLeft: "-5px", paddingLeft: 0 })
                }}
              >
                <CustomToolTipHost
                  content={raiseAlertValue
                    ? `${t("study-list.badges.raise-alert", "Alert Raised")}: ${getRaiseAlertLabel(raiseAlertValue)}`
                    : t("placeholder.raise-alert")}
                  id="raise-alert-tooltip"
                >
                  <DefaultButton
                    text={t("label.raise-alert", "Raise Alert")}
                    iconProps={{ iconName: raiseAlertValue ? "RingerSolid" : "Ringer" }}
                    onClick={handleRaiseAlertClick}
                    disabled={!isActiveData || scanning || loaderRunning}
                    styles={isMobile ? updatedStylesEnableMobileSuspect : updatedStylesDisable}
                  />
                </CustomToolTipHost>
              </div>
            )}
            {/* Raise Alert dropdown - moved to beginning of right side group */}
            {/* {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR)) && enableLlmReport && isLLMAgentPresent(props.modality, studyDescription ) && !disableRaiseAlert && (
              <div className="form-field" style={{ width: "100%", maxWidth: "150px", marginRight: "3%", fontSize: "14px" }}>
                <CreatableSelect
                  menuPlacement="auto"  
                  classNamePrefix="react-select" 
                  styles={stylesForCustomSelect(getThemeColor)} 
                  defaultValue={
                    raiseAlertValue != undefined &&
                    raiseAlertValue != null &&
                    raiseAlertValue != ""
                      ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                      : null
                  }
                  onChange={(ele) => {
                    handleRaiseAlertDropdown(ele);
                  }}
                  placeholder={t("placeholder.raise-alert")}
                  isClearable
                  options={raiseAlertList}
                />
              </div>
            )} */}
            
            {/* Row 1 action buttons */}
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "6px" }}>
            {activeTab !== 3 && !disableMarkAsSuspect && !isChildStudyReportState && !PlatformHelper.isFahes() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto", ...(isMobile && { flexShrink: 0 }) }}>
                <DefaultButton
                  text={t("button.suspect")}
                  onClick={handleMarkAsSuspect}
                  disabled={disableMarkAsSuspect || !isActiveData}
                  styles={isMobile ? updatedStylesEnableMobileSuspect : updatedStylesEnable}
                />
              </div>
            )}

            {activeTab !== 3 && !disablePreview && !isChildStudyReportState && (
              <div className="download-box-wrapper form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.preview")}
                  disabled={disablePreview}
                  styles={updatedStylesDisable}
                  onClick={() => {
                    // Let the system decide: preview with key images if present, else plain report
                    const hasKeyImages = props.isStudyList
                      ? keyImagePresentStudyList
                      : keyImagePresentStudyList || keyImagesPresent(props.keyImages);
                    if (hasKeyImages) {
                      handlePreviewReportWithKeyImage(studyParentId);
                    } else {
                      handlePreviewReport(studyParentId);
                    }
                  }}
                />
              </div>
            )}

            {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) &&
              !disableDownload && !isChildStudyReportState && (
                <div className="download-box-wrapper form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                  <DefaultButton
                    text={t("button.download")}
                    disabled={disableDownload}
                    styles={updatedStylesDisable}
                    onClick={() => {
                      if (showInfo1) {
                        setShowInfo1(false);
                      } else {
                        setShowInfo1(true);
                      }
                    }}
                  />
                  <DownloadOptions
                    studyParentId={studyParentId}
                    show={showInfo1}
                    onClickOutside={() => {
                      setShowInfo1(false);
                    }}
                    modality={props.modality}
                    isKeyImagesPresent={props.isStudyList ? keyImagePresentStudyList : keyImagePresentStudyList || keyImagesPresent(props.keyImages)}
                    isExtReportReceived={extReportRecieved}
                  />
                </div>
              )
            }

            {!isMobile && activeTab !== 3 && !(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && showMsWord && !PlatformHelper.isFahes() && !disableEditReport &&(
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  onClick={() => {
                    handleDownloadDoc(studyParentId)
                  }}
                  iconProps={{iconName:"OpenInNewWindow"}}
                  text={`MS-Word`}
                  styles={updatedStylesEnableMSWord}
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCReason && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-reason")}
                  onClick={() => setOpenQcReasonModal(true)}
                  styles={updatedStylesDisable}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCPass && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-pass")}
                  styles={formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingQCPass : updatedStylesDisable}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() => handleQcPassClick(false)}
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCPass && !isChildStudyReportState && formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 && hasAgenticReport && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-pass")}
                  styles={updatedStylesDisable}
                  onClick={() => handleQcPassClick(true)}
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCReturn && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-return")}
                  styles={updatedStylesDisable}
                  onClick={() =>
                    handleQcReturnButtonClick(studyParentId, props.qcData)
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab === 3 && !disableEditReport && (isExternal || !NONXRAYMODALITIES.includes(props.modality)) && (
              <PrimaryButton
                className="report-button"
                text={t("studyviewer.regenerate-report")}
                styles={updatedStylesEnable}
                onClick={handleDSRRegenerate}
              />
            )}
            </div>
            </div>{/* end Row 1 */}

            {/* Row 2: Save Draft + Preliminary + Submit / Positive / Negative */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginLeft: hasRow1ActionButtons() ? undefined : "auto" }}>
            {checkForSaveButton() &&
              (roles.includes(USERTYPES.RADIOLOGIST) ||
                roles.includes(USERTYPES.TYPIST)) &&
              handleSaveDraft && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.save-draft")}
                  onClick={() =>
                    handleSaveDraft(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex
                    )
                  }
                  disabled={
                    !isActiveData || (isClientReportExist == true && patientReports.length == 0) || loaderRunning
                  }
                  styles={isMobile ? mobileCompactButton : updatedStylesDisable}
                />
              </div>
            )}

            {checkForSaveButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={
                    roles.includes(USERTYPES.RADIOLOGIST) ||
                    roles.includes(USERTYPES.TYPIST)
                      ? t("button.preliminary")
                      : t("button.save")
                  }
                  onClick={() => {
                    /* NEW (Raise Alert feature): scans and prompts before releasing,
                       like Submit and QC Pass. handlePreliminaryClick role-gates it
                       itself, so the "Save" reading of this same button stays silent. */
                    const markAsPreliminary = () =>
                      handlePreliminaryClick({
                        keyImages: props.keyImages,
                        annotationData: props.annotationData,
                        annotationDataAI: props.annotationDataAI,
                        allTextToolAnnotation: props.allTextToolAnnotation,
                        activeViewportIndex: props.activeViewportIndex,
                      });
                    if (
                      roles.includes(USERTYPES.RADIOLOGIST) &&
                      showPreliminaryActionPopup &&
                      reportDoneStatusState !== REPORTDONESTATUS.QC_FIX &&
                      reportDoneStatusState !== REPORTDONESTATUS.PRELIMINARY_QC_FIX
                    ) {
                      setShowPreliminaryActionModal(true);
                      return;
                    }
                    markAsPreliminary();
                  }}
                  disabled={
                    !isActiveData ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) ||
                    loaderRunning
                  }
                  styles={isMobile ? mobileCompactButton : updatedStylesDisable}
                />
              </div>
            )}

            {checkForSubmitButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.submit")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={handleSubmitClick}
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={isMobile ? mobileCompactButton : (formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingSubmit : updatedStylesEnable)}
                />
              </div>
            )}
            {checkForPositiveNegativeButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.negative")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleNegativeSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false,undefined,undefined,undefined,
                      false,
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={{
                      root: {
                        backgroundColor: "#4CAF50",
                        borderColor: "#4CAF50",
                      },
                      rootHovered: {
                        backgroundColor: "#43A047",
                        borderColor: "#43A047",
                      },
                      rootPressed: {
                        backgroundColor: "#388E3C",
                        borderColor: "#388E3C",
                      },
                    }}
               />
              </div>
            )}

            {checkForPositiveNegativeButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.positive")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false,undefined,undefined,undefined,true,
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={{
                      root: {
                        backgroundColor: "#FB8C00",
                        borderColor: "#FB8C00",
                      },
                      rootHovered: {
                        backgroundColor: "#F57C00",
                        borderColor: "#F57C00",
                      },
                      rootPressed: {
                        backgroundColor: "#EF6C00",
                        borderColor: "#EF6C00",
                      },
                    }}
                />
              </div>
            )}
            </div>{/* end Row 2 */}

          </div>{/* end bottom-button */}
        </div>{/* end inner flex div */}

        {openQCPassConfirmModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <QCPassConfirmModal
              keyImages={props.keyImages}
              qcData={props.qcData}
              allTextToolAnnotation={props.allTextToolAnnotation}
            />
          </div>
        )}

        {/* NEW (Raise Alert feature): critical-finding confirmation modal. Findings come from
            the real scan; persistence still rides the existing raiseAlert field. */}
        <CriticalAlertConfirmModal
          isOpen={showCriticalAlertModal}
          mode={criticalAlertMode}
          detectedFindings={detectedFindings}
          preConfirmedManual={preConfirmedManual}
          catalogue={alertCatalogue}
          onClose={() => setShowCriticalAlertModal(false)}
          onSkip={() => {
            // Declined. Retire whatever was raised before — "without alert" has to
            // actually mean no alert, otherwise the badge keeps showing findings
            // that were just declined.
            console.warn(`[Raise Alert feature] declined in ${criticalAlertMode} mode — proceeding with no alert`);
            setShowCriticalAlertModal(false);
            if (criticalAlertMode === "QC_PASS") {
              retireAutoDetectedThenQcPass(pendingQcAgentic, true); // declined in the modal
            } else if (criticalAlertMode === "PRELIMINARY") {
              retireAutoDetectedThenPreliminary(true); // declined in the modal
            } else {
              retireAutoDetectedThenSubmit(true); // declined in the modal
            }
          }}
          onConfirm={(selectedFindings) => {
            setShowCriticalAlertModal(false);
            applyConfirmedFindings(selectedFindings);
            if (criticalAlertMode === "SUBMIT") {
              setSubmitAfterAlert(true);
            } else if (criticalAlertMode === "QC_PASS") {
              setQcPassAfterAlert(true);
            } else if (criticalAlertMode === "PRELIMINARY") {
              setPreliminaryAfterAlert(true);
            }
          }}
        />

        <PreliminaryActionModal
          isOpen={showPreliminaryActionModal}
          onClose={() => setShowPreliminaryActionModal(false)}
          onContinue={() => {
            setShowPreliminaryActionModal(false);
            /* NEW (Raise Alert feature): the second route to the same release. A
               radiologist with the preliminary-action popup enabled reaches Mark as
               Preliminary from here instead of straight off the button, so it has to
               scan too -- otherwise the prompt appears for some radiologists and not
               others depending on a firm setting. */
            handlePreliminaryClick({
              keyImages: props.keyImages,
              annotationData: props.annotationData,
              annotationDataAI: props.annotationDataAI,
              allTextToolAnnotation: props.allTextToolAnnotation,
              activeViewportIndex: props.activeViewportIndex,
            });
          }}
          onRelease={() => {
            setShowPreliminaryActionModal(false);
            handlePreliminaryClick({
              keyImages: props.keyImages,
              annotationData: props.annotationData,
              annotationDataAI: props.annotationDataAI,
              allTextToolAnnotation: props.allTextToolAnnotation,
              activeViewportIndex: props.activeViewportIndex,
              preliminaryPostAction: "release",
            });
          }}
          onReadyForReviewAndRelease={() => {
            setShowPreliminaryActionModal(false);
            handlePreliminaryClick({
              keyImages: props.keyImages,
              annotationData: props.annotationData,
              annotationDataAI: props.annotationDataAI,
              allTextToolAnnotation: props.allTextToolAnnotation,
              activeViewportIndex: props.activeViewportIndex,
              preliminaryPostAction: "readyForReview",
            });
          }}
        />
        
        {openQcModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <QCFailModal keyImages={props.keyImages} qcData={props.qcData} allTextToolAnnotation={props.allTextToolAnnotation}/>
          </div>
        )}
        
        {/* OLD (Fistulogram upload modal): commented out, replaced by unified FistolugramModal below */}
        {/* {openFistolugramUploadModal && studyParentId != null && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <UploadFistolugramModal studyParentId={studyParentId} />
          </div>
        )} */}

        {/* Fistulogram + Fibroid modals — both render the same AnnotatedImageModal,
            differing only in config (endpoints, reference image, IDs). */}
        {openFistolugramModal && studyParentId != null && (
          <AnnotatedImageModal
            studyParentId={studyParentId}
            config={FISTULOGRAM_CONFIG}
            filePath={fistolugramFilePath}
            onClose={() => setOpenFistolugramModal(false)}
            downloadImageAsBlob={downloadFistolugramImageAsBlob}
            uploadFunc={uploadFistolugramFunc}
            deleteFunc={deleteFistolugramFunc}
          />
        )}

        {openFibroidModal && studyParentId != null && (
          <AnnotatedImageModal
            studyParentId={studyParentId}
            config={FIBROID_CONFIG}
            filePath={fibroidFilePath}
            patientSex={studyPatientSex}
            onClose={() => setOpenFibroidModal(false)}
            downloadImageAsBlob={downloadFibroidImageAsBlob}
            uploadFunc={uploadFibroidFunc}
            deleteFunc={deleteFibroidFunc}
          />
        )}
        
        {openQcReasonModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <QCReasonModal
              patientName={props.patientName}
              patientId={props.patientId}
            />
          </div>
        )}
      </div>}
      
      {isChildStudyReportState && 
        <div style={{ width: "100%" }} className="ms-Grid-row viewer-outline-heatmap-text">
          {t("string-literals.prior-study")}
        </div>
      }
  
    </div>
  );
}
};
  export default AlertSubmitSection;